/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../base.component';
import { Component, Input } from '@angular/core';
import { NavigationService } from '../../services';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared.module';

@Component({
    selector: 'app-breadcrumbs',
    standalone: true,
    imports: [
        SharedModule
    ],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent extends BaseComponent {
    /**
     * Route back name
     */
    @Input() public routeBackName: string = '/';

    /**
     * Route back url.
     */
    @Input() public routeBackUrl: string = '/';

    /**
     * Current page title.
     */
    @Input() public pageTitle: string = 'page_title';

    constructor(
        private navigationService: NavigationService,
        private router: Router,
    ) {
        super();
    }

    /**
     * Back to previous page.
     */
    public back() {
        this.router.navigateByUrl(this.navigationService.getEnduranceUrl(this.routeBackUrl)).then().catch();
    }

}
